<ng-container *ngIf="!!imageId && !!imageUrl">
	<img [src]="imageUrl" [alt]="alt || 'Uploaded Image'" />
</ng-container>
<ng-container *ngIf="!imageId && !!resolvedImage">
	<img [src]="domSanitizer.bypassSecurityTrustResourceUrl(resolvedImage)" alt="Image waiting for upload" />
</ng-container>
